import React, { JSX } from 'react';
import { ApiItinerary } from '@ibe/api';
import { Col, Row } from 'reactstrap';
import fallback from '../../../_Translations/generated/package-details.en.t.json';
import Keys from '../../../_Translations/generated/package-details.en.t.json.keys';
import useTranslation from '../../Hooks/useTranslation';

interface Props {
  chunk: Array<ApiItinerary>;
  renderCarouselRowIsSmall: boolean;
  itineraries?: ApiItinerary[];
  activeDayId: number;
  setActiveDayId: (activeDayId: number) => void;
}

const SingleItem = (singleItemProps: {
  singleItem: ApiItinerary;
  itemIsSmall: boolean;
  itineraries?: ApiItinerary[];
  activeDayId: number;
  setActiveDayId: (activeDayId: number) => void;
}): JSX.Element => {
  const { singleItem, itemIsSmall, itineraries, activeDayId, setActiveDayId } = singleItemProps;
  const { t } = useTranslation('package-details', fallback, Keys);
  const foundIndex = itineraries
    ? itineraries.findIndex((x): boolean => x.numberOfDay === singleItem.numberOfDay)
    : 0;
  const isSelected = foundIndex === activeDayId;

  return (
    <Col
      className={`mx-2 border ${
        (itemIsSmall ? 'col-9 itinerary__item ' : 'col-3 itinerary__item ') +
        (isSelected ? 'itinerary__item--active' : '')
      }`}
      onClick={(): void => {
        if (singleItem.numberOfDay) setActiveDayId(foundIndex);
      }}
    >
      <Row className="justify-content-center mt-1">
        <h5>{`${t(Keys.day)} ${singleItem.numberOfDay}`}</h5>
      </Row>
      <Row className="justify-content-center px-2 mb-1 text-center">
        <div className="itinerary__item__subTitle">{singleItem.title}</div>
      </Row>
    </Col>
  );
};

const CarouselRow = (props: Props): JSX.Element => {
  const { chunk, renderCarouselRowIsSmall, itineraries, setActiveDayId, activeDayId } = props;

  return (
    <Row className="justify-content-center mx-2">
      {chunk &&
        chunk.map(
          (element): JSX.Element => {
            return (
              <SingleItem
                singleItem={element}
                itemIsSmall={renderCarouselRowIsSmall}
                key={`${element.title}${element.numberOfDay}`}
                activeDayId={activeDayId}
                setActiveDayId={setActiveDayId}
                itineraries={itineraries}
              />
            );
          }
        )}
    </Row>
  );
};

export default CarouselRow;
